

export class Employee_Dashboard_Instruction_Detail implements IEmployee_Dashboard_Instruction_Detail {
    title!: string | undefined;
    description!: string | undefined;
    createdOn!: Date | undefined;

    constructor(data?: IEmployee_Dashboard_Instruction_Detail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Employee_Dashboard_Instruction_Detail {
        data = typeof data === 'object' ? data : {};
        let result = new Employee_Dashboard_Instruction_Detail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IEmployee_Dashboard_Instruction_Detail {
    title: string | undefined;
    description: string | undefined;
    createdOn: Date | undefined;
}

